// AUTO-GENERATED FILE - DO NOT EDIT
// Run `bun run genTeeth` instead.
/* istanbul ignore file */
/* eslint-disable */
import ToothModelHollowHingedEmbossedNone from '@/assets/tooth-models/hollow-hinged-embossed-none.svg';
import ToothModelHollowHingedEmbossedPalate from '@/assets/tooth-models/hollow-hinged-embossed-palate.svg';
import ToothModelHollowHingedEngravedNone from '@/assets/tooth-models/hollow-hinged-engraved-none.svg';
import ToothModelHollowHingedEngravedPalate from '@/assets/tooth-models/hollow-hinged-engraved-palate.svg';
import ToothModelHollowHingedNoneNone from '@/assets/tooth-models/hollow-hinged-none-none.svg';
import ToothModelHollowHingedNonePalate from '@/assets/tooth-models/hollow-hinged-none-palate.svg';
import ToothModelHollowNoneEmbossedNone from '@/assets/tooth-models/hollow-none-embossed-none.svg';
import ToothModelHollowNoneEmbossedPalate from '@/assets/tooth-models/hollow-none-embossed-palate.svg';
import ToothModelHollowNoneEngravedNone from '@/assets/tooth-models/hollow-none-engraved-none.svg';
import ToothModelHollowNoneEngravedPalate from '@/assets/tooth-models/hollow-none-engraved-palate.svg';
import ToothModelHollowNoneNoneNone from '@/assets/tooth-models/hollow-none-none-none.svg';
import ToothModelHollowNoneNonePalate from '@/assets/tooth-models/hollow-none-none-palate.svg';
import ToothModelHollowPillarsEmbossedNone from '@/assets/tooth-models/hollow-pillars-embossed-none.svg';
import ToothModelHollowPillarsEmbossedPalate from '@/assets/tooth-models/hollow-pillars-embossed-palate.svg';
import ToothModelHollowPillarsEngravedNone from '@/assets/tooth-models/hollow-pillars-engraved-none.svg';
import ToothModelHollowPillarsEngravedPalate from '@/assets/tooth-models/hollow-pillars-engraved-palate.svg';
import ToothModelHollowPillarsNoneNone from '@/assets/tooth-models/hollow-pillars-none-none.svg';
import ToothModelHollowPillarsNonePalate from '@/assets/tooth-models/hollow-pillars-none-palate.svg';
import ToothModelSolidHingedEmbossedNone from '@/assets/tooth-models/solid-hinged-embossed-none.svg';
import ToothModelSolidHingedEmbossedPalate from '@/assets/tooth-models/solid-hinged-embossed-palate.svg';
import ToothModelSolidHingedEngravedNone from '@/assets/tooth-models/solid-hinged-engraved-none.svg';
import ToothModelSolidHingedEngravedPalate from '@/assets/tooth-models/solid-hinged-engraved-palate.svg';
import ToothModelSolidHingedNoneNone from '@/assets/tooth-models/solid-hinged-none-none.svg';
import ToothModelSolidHingedNonePalate from '@/assets/tooth-models/solid-hinged-none-palate.svg';
import ToothModelSolidNoneEmbossedNone from '@/assets/tooth-models/solid-none-embossed-none.svg';
import ToothModelSolidNoneEmbossedPalate from '@/assets/tooth-models/solid-none-embossed-palate.svg';
import ToothModelSolidNoneEngravedNone from '@/assets/tooth-models/solid-none-engraved-none.svg';
import ToothModelSolidNoneEngravedPalate from '@/assets/tooth-models/solid-none-engraved-palate.svg';
import ToothModelSolidNoneNoneNone from '@/assets/tooth-models/solid-none-none-none.svg';
import ToothModelSolidNoneNonePalate from '@/assets/tooth-models/solid-none-none-palate.svg';
import ToothModelSolidPillarsEmbossedNone from '@/assets/tooth-models/solid-pillars-embossed-none.svg';
import ToothModelSolidPillarsEmbossedPalate from '@/assets/tooth-models/solid-pillars-embossed-palate.svg';
import ToothModelSolidPillarsEngravedNone from '@/assets/tooth-models/solid-pillars-engraved-none.svg';
import ToothModelSolidPillarsEngravedPalate from '@/assets/tooth-models/solid-pillars-engraved-palate.svg';
import ToothModelSolidPillarsNoneNone from '@/assets/tooth-models/solid-pillars-none-none.svg';
import ToothModelSolidPillarsNonePalate from '@/assets/tooth-models/solid-pillars-none-palate.svg';

export const ToothModelHollowHingedEmbossedNoneSVG = ToothModelHollowHingedEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEmbossedPalateSVG = ToothModelHollowHingedEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedNoneSVG = ToothModelHollowHingedEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedPalateSVG = ToothModelHollowHingedEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNoneNoneSVG = ToothModelHollowHingedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNonePalateSVG = ToothModelHollowHingedNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedNoneSVG = ToothModelHollowNoneEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedPalateSVG = ToothModelHollowNoneEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedNoneSVG = ToothModelHollowNoneEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedPalateSVG = ToothModelHollowNoneEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNoneNoneSVG = ToothModelHollowNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNonePalateSVG = ToothModelHollowNoneNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedNoneSVG = ToothModelHollowPillarsEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedPalateSVG = ToothModelHollowPillarsEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedNoneSVG = ToothModelHollowPillarsEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedPalateSVG = ToothModelHollowPillarsEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNoneNoneSVG = ToothModelHollowPillarsNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNonePalateSVG = ToothModelHollowPillarsNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedNoneSVG = ToothModelSolidHingedEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedPalateSVG = ToothModelSolidHingedEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedNoneSVG = ToothModelSolidHingedEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedPalateSVG = ToothModelSolidHingedEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNoneNoneSVG = ToothModelSolidHingedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNonePalateSVG = ToothModelSolidHingedNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedNoneSVG = ToothModelSolidNoneEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedPalateSVG = ToothModelSolidNoneEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedNoneSVG = ToothModelSolidNoneEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedPalateSVG = ToothModelSolidNoneEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNoneNoneSVG = ToothModelSolidNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNonePalateSVG = ToothModelSolidNoneNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedNoneSVG = ToothModelSolidPillarsEmbossedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedPalateSVG = ToothModelSolidPillarsEmbossedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedNoneSVG = ToothModelSolidPillarsEngravedNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedPalateSVG = ToothModelSolidPillarsEngravedPalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNoneNoneSVG = ToothModelSolidPillarsNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNonePalateSVG = ToothModelSolidPillarsNonePalate as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
